import React from 'react';
import { Typography } from '@mui/material';
import GenericPage from '../../Commun/components/GenericPage';

const NotificationsPage: React.FC = () => {
    return (
        <GenericPage title="Notifications">
            <Typography variant="body1">Page des notifications (en cours de développement)</Typography>
        </GenericPage>
    );
};

export default NotificationsPage;
